import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import {
  EDIT_BASES,
  ADD_NEW_BASES,
  SET_ERROR_MESSAGE_BASES,
  ARCHIVE_ERROR_MESSAGE_BASES,
  ARCHIVE_LOADING_BASES,
  ARCHIVE_SUCCESS_BASES,
} from "../types";
import {
  MAIN_URL,
  PORT,
  API_EDIT_BASES_BUILDING,
  API_ADD_BASES_BUILDING,
  API_ADD_BASES_ARCHIVE,
} from "../../constants/constants";

export function editDataBasesBuildings(building) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_EDIT_BASES_BUILDING + `${building.parkId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(building),
      },
    );
    if (response.ok) {
      dispatch({
        type: EDIT_BASES,
        data: building,
      });
    } else {
      dispatch({
        type: SET_ERROR_MESSAGE_BASES,
        data: await response.text(),
      });
    }
  };
}

export function addDataBasesBuildings(building) {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_ADD_BASES_BUILDING,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(building),
      },
    );
    if (response.ok) {
      building.parkId = await response.json();
      dispatch({
        type: ADD_NEW_BASES,
        data: building,
      });
    } else {
      dispatch({
        type: SET_ERROR_MESSAGE_BASES,
        data: await response.text(),
      });
    }
  };
}

export function archiveBasesBuildings(buildingId) {
  return async (dispatch) => {
    dispatch({ type: ARCHIVE_LOADING_BASES });
    const response = await fetchWithToken(
      MAIN_URL + PORT + API_ADD_BASES_ARCHIVE + `${buildingId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (response.ok) {
      dispatch({
        type: ARCHIVE_SUCCESS_BASES,
      });
    } else {
      dispatch({
        type: ARCHIVE_ERROR_MESSAGE_BASES,
        data: await response.json(),
      });
    }
  };
}
